import allowedZips from "./allowed-zips.json";

const zipMap = allowedZips as Record<string, string>;

const FALLBACK_CITY = "Your Area";

export function lookupZip(zip: string): string | null {
  if (!/^\d{5}$/.test(zip)) return null;
  return zipMap[zip] ?? FALLBACK_CITY;
}

export function isValidZip(zip: string): boolean {
  return /^\d{5}$/.test(zip);
}
